import {
  CUSTOMERS_LIST,
  CUSTOMERS_DETAIL,
  LOADING,
  NOT_FOUND,
} from "../action/type";

const initialState = {
  list: [],
  totalDocs: 0,
  totalPages: 0,
  loading: false,
  not_found: false,
};
const customers = (state = initialState, action) => {
  switch (action.type) {
    case LOADING:
      return { ...state, loading: true, not_found: false };
    case NOT_FOUND:
      return { ...state, list: [], loading: false, not_found: true };
    case CUSTOMERS_LIST:
      return {
        ...state,
        list: action.payload.docs || action.payload,
        totalDocs: action.payload.totalDocs || 0,
        totalPages: action.payload.totalPages || 0,
        loading: false,
        not_found: false,
      };
    case CUSTOMERS_DETAIL:
      // Assuming detail payload is just the user object, but existing code put it in 'list'?
      // Leaving as is if it might break other things, but usually detail shouldn't replace list.
      // If Detail view uses a different state, it should be fine.
      // Based on previous code: return { ...state, list: action.payload ...}
      // Let's keep it safe for now, though it looks suspicious for a 'detail' action.
      return {
        ...state,
        list: action.payload,
        loading: false,
        not_found: false,
      };
    default:
      return state;
  }
};

export default customers;
